import useDialog from './useDialog';

export default useDialog;

export * from './useDialog';
